import { computed } from 'vue';
import { MONET_URL } from '@/static/urls';
import { Routes } from '@/models/router/router.interface';
import { DashboardAccessItem, ActClientProductPayment } from '@/models/dashboard-data.interface';
import { LoadingState } from '@/models/loading.interface';
import DataTracker from '@/infrastructure/data-tracker';
import store from '@/store';

export default class ActiveDashboardsOverviewCode {

	public isLoading = computed((): boolean => {
		const loadingState = store.getters.loadingStateDashboards();
		return loadingState === LoadingState.ACTIVE;
	})

	public activeDashboards = computed((): DashboardAccessItem[] => {
		return store.getters.activeDashboards();
	});

	private tracker = computed((): DataTracker => {
		return store.getters.tracker();
	});

	public retrieveIconUrlForDashboard(dashboard: DashboardAccessItem): string {
		return `${MONET_URL}module_${dashboard.tag}.png`;
	}

	public retrieveAccessLabel(dashboard: DashboardAccessItem): string {
		if (dashboard.type === ActClientProductPayment.FREE) {
			return 'Unlimited';
		}

		const date = dashboard.endDate;
		if (!date) {
			return '';
		}

		const dateString = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
		return `Access until: ${dateString}`;
	}

	public navigateToDashboard(productNumber: string): void {
		this.tracker.value.trackDashboardClick(productNumber, true);
		store.mutations.setCurrentRoute(Routes.SELECTED_DASHBOARD, productNumber);
		// Scroll to the top of the page.
		window.scrollTo(0, 0);
	}
}
